import { NgIf } from "@angular/common";
import { Component } from "@angular/core";
import { OrganizationCreationComponent } from "./gueteGemeinschaftOrganizationCreation.component";
import { NewUiGueteGemeinschaftLinkHandlingComponent } from "./new-ui-gueteGemeinschaftLinkHandling.component";

@Component({
  selector: "app-guetegemeinschaft-link-handling",
  templateUrl: "./gueteGemeinschaftLinkHandling.component.html",
  styleUrl: "./gueteGemeinschaftLinkHandling.component.scss",
  imports: [NgIf, OrganizationCreationComponent],
})
export class GueteGemeinschaftLinkHandlingComponent extends NewUiGueteGemeinschaftLinkHandlingComponent {}
